import { render, staticRenderFns } from "./SidebarClass.vue?vue&type=template&id=5f73f567&scoped=true&"
import script from "./SidebarClass.vue?vue&type=script&lang=js&"
export * from "./SidebarClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f73f567",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/app/site2/src/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f73f567')) {
      api.createRecord('5f73f567', component.options)
    } else {
      api.reload('5f73f567', component.options)
    }
    module.hot.accept("./SidebarClass.vue?vue&type=template&id=5f73f567&scoped=true&", function () {
      api.rerender('5f73f567', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Proprietaire/SidebarClass.vue"
export default component.exports